/* eslint-disable react/no-is-mounted */
import React from "react";
import { OcErrorBoundaryInfo } from "oc/components";

interface OcErrorBoundaryProps {
  children?: React.ReactNode;
}

interface OcErrorBoundaryState {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

export class OcErrorBoundary extends React.Component<
  OcErrorBoundaryProps,
  OcErrorBoundaryState
> {
  constructor(props: OcErrorBoundaryProps) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <OcErrorBoundaryInfo
          error={this.state.error!}
          errorInfo={{
            componentStack: this.state.errorInfo?.componentStack || "",
          }}
        />
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}

export default OcErrorBoundary;
